module.exports = __webpack_public_path__ + "static/media/iconMore.ddaae515.svg";